<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('readTaskList.title')" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('readTaskList.order')" prop="order">
          <el-input
            @input="
              (res) => {
                this.ruleForm.order = +res;
              }
            "
            @mousewheel.native.prevent  
            @DOMMouseScroll.native.prevent 
            type="number"
            placeholder="정렬순이 높은 건이 우선 노출됩니다."
            v-model="ruleForm.order"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('readTaskList.active')" prop="active">
          <el-radio-group size="medium" v-model="ruleForm.active">
            <el-radio :label="0">{{ $t("readTaskList.active0") }}</el-radio>
            <el-radio :label="1">{{ $t("readTaskList.active1") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('readTaskList.end_time')" prop="end_time">
          <el-date-picker
            v-model="ruleForm.end_time"
            type="datetime"
            :placeholder="$t('select_date')"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('readTaskList.content')" prop="content">
          <div v-if="load">
            <SummerNote
              :id="'summernote' + new Date().getTime()"
              v-model="ruleForm.content"
            />
          </div>
        </el-form-item>
      </el-form>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t("btnTip.submit")
      }}</el-button>
    </el-card>
  </div>
</template>
<script>
import SummerNote from "@/components/summernote";
import { readTaskDetail, addReadTask, editReadTask } from "@/api/api";
export default {
  name: "editReadTask",
  data() {
    return {
      ruleForm: {
        title: "",
        order: 0,
        active: "",
        content: "",
        end_time: "",
        club: this.$route.params.readId,
      },
      rules: {
        title: [
          {
            required: true,
            message: this.$t("readTaskList").title,
            trigger: "blur",
          },
        ],
        order: [
          {
            required: true,
            message: '정렬순이 높은 건이 우선 노출됩니다.',
            trigger: "blur",
          },
        ],
        end_time: [
          {
            required: true,
            message: this.$t("readTaskList").end_time,
            trigger: "blur",
          },
        ],
        active: [
          {
            required: true,
            message: this.$t("readTaskList").active,
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("readTaskList").content,
            trigger: "blur",
          },
        ],
      },
      load: false,
    };
  },
  components: { SummerNote },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t("btnTip").add
        : this.$t("btnTip").edit;
    },
  },
  watch: {
    
  },
  methods: {
    async submitForm(formName) {
      await this.$refs[formName].validate();
      if (this.id === undefined) {
        await addReadTask(this.ruleForm);
      } else {
        delete this.ruleForm.create_time;
        delete this.ruleForm.publisher_name;
        delete this.ruleForm.type;
        await editReadTask(this.ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await readTaskDetail(this.id);
      this.ruleForm = { ...information };
      this.load = true;
    },
  },
  async created() {
    if (this.id === undefined) {
      this.load = true;
      return;
    }
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>
